module.exports = __webpack_public_path__ + "img/ImageHover1.b90acd7f.png";